import apiFetch from '../apiFetch'
export default function (orderId, order, token, lastAccessDate) {
  return apiFetch({ endPoint: `order/${orderId}`, method: 'PUT', body: order, token: token, lastAccessDate })
}
